module.exports = __webpack_public_path__ + "static/media/Coming_Soon@3x.c4ade146.png";